/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
// import fetch from 'dva/fetch';
import router from '@/router'
import net from '@/constants'
import { getToken } from '@/utils/auth'
import { Message, Notification } from 'element-ui'

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}
/**
 * 异常处理程序
 */
const errorHandler = error => {
  const { response = {} } = error
  const errortext = codeMessage[response.status] || response.statusText
  const { status } = response
  const { url } = response.config
  Notification.error({
    title: `请求错误 ${status}: ${url}`,
    message: errortext
  })
}
/**
 * 配置request请求时的默认参数
 */

export default function exportRequest (url, options) {
  const defaultOptions = {
    credentials: 'include'
    // errorHandler,
  }
  const newOptions = { ...defaultOptions, ...options }
  if (newOptions.method === 'GET') {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      responseType: 'blob',
      Authorization: 'CsxhBearer ' + getToken()
    }
  }
  // newOptions.params = newOptions.params
  // const resUrl = `${net.PREFIX_URL}${url}`
  const resUrl = net.baseUrl + url + '?fileName=' + newOptions.params.fileName + '&delete=true'
  return fetch(resUrl, newOptions).then(async response => {
    if (response.status < 200 || response.status >= 300) {
      errorHandler(response)
    }
    try {
      const data = await response.clone().json()
      // 判断是否被踢了
      if (data && data.ret_code && data.ret_code === '401') {
        (() => {
          Message.error(data.ret_msg || '对不起，您还未登录，请先登录后再试！')
          router.push('/user/login')
          sessionStorage.clear()
        })()
      }
      return data
    } catch (err) {
      console.log(err)
      return response.blob()
    }
  })
}
